import React, { useEffect, useState }from "react";
import { Modal, Form, Input, Checkbox, notification } from "antd";
import _ from 'lodash';

const ChannelModal = ({ visible, closeDialog, channelData, afterClose }) => {
  
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
        xs: { span: 8 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 },
    },
  };

  const checkboxStyle = {
    margin: '0px 0'
  }

  useEffect(() => {

    const newFormValues = {
      address: "",
      comments: "",
      name: "",
      sendAttachment: false,
      sendLink: true,
      sendWebTools: false
    }

    if(visible) {
      form.resetFields();
      form.setFieldsValue(channelData?.id ? channelData : { ...channelData, ...newFormValues });
    }
  }, [form, visible, channelData])

  const onOk = () => {
    form.submit();
  }

  const handleSubmit = (formValues) => {
    setLoading(true)

    if(channelData.id) {
      axios.post('/api/users/dto/userman/channelstab/update', { channelsTab: { deliveries: [formValues] }}).then((res) => {
        setLoading(false);
        closeDialog(true);
        notification.success({ message: `Channel updated.` });
      })
    }
    else {
      axios.post('/api/users/dto/userman/delivery/create', { id: formValues.userId, deliveries: [formValues] }).then((res) => {
        setLoading(false);
        closeDialog(true);
        notification.success({ message: `Channel added.` });
      })
    }
  }

  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={closeDialog}
      width="450px"
      title={`${channelData?.id ? "Edit" : "Add"} User Channel`}
      forceRender={true}
      getContainer=".modal-mount"
      afterClose={afterClose}
      confirmLoading={loading}
      destroyOnClose={true}
      maskClosable={false}
    >
      <Form form={form} onFinish={handleSubmit} {...formItemLayout} labelAlign="left" autoComplete="off" name="editChannelForm" hideRequiredMark>
        <Form.Item name="userId" hidden>
            <Input style={{ width: '100%' }}  disabled={true} />
        </Form.Item>
        <Form.Item name="id" hidden>
            <Input style={{ width: '100%' }}  disabled={true} />
        </Form.Item>
        <Form.Item name="enabled" hidden>
            <Input style={{ width: '100%' }}  disabled={true} />
        </Form.Item>
        <Form.Item label="Channel Name" name="description" style={{ marginBottom: '8px',  }}>
            <Input style={{ width: '100%' }}  disabled={true} />
        </Form.Item>
        <Form.Item label="Delivery Name" name="name" style={{ marginBottom: '8px' }}>
            <Input style={{ width: '100%' }}  disabled={channelData?.id} />
        </Form.Item>
        <Form.Item label="Address" name="address" rules={[{ whitespace: true, required: true, message: 'Email address required!' }]} style={{ marginBottom: '8px' }}>
            <Input style={{ width: '100%' }}  disabled={!_.isEmpty(channelData) && channelData?.channelId !== 1} />
        </Form.Item>
        <Form.Item label="Comments" name="comments" style={{ marginBottom: '15px' }}>
            <Input.TextArea style={{ width: '100%' }}  />
        </Form.Item>
        {channelData?.channelId === 1 &&
          <>
            <Form.Item name="sendLink" valuePropName="checked" style={checkboxStyle} wrapperCol={{ span: 24 }}>
              <Checkbox>Include Document Locator link</Checkbox>
            </Form.Item>
            <Form.Item name="sendAttachment" valuePropName="checked" style={checkboxStyle} wrapperCol={{ span: 24 }}>
              <Checkbox>Include file attachment</Checkbox>
            </Form.Item>
            <Form.Item name="sendWebTools" valuePropName="checked" style={checkboxStyle} wrapperCol={{ span: 24 }}>
              <Checkbox>Include Document Locator WebTools link</Checkbox>
            </Form.Item>
          </>
        }
      </Form>
    </Modal>
  );
};

export default ChannelModal;
